<form
  class="sign-up-form"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  [formGroup]="form"
  (ngSubmit)="submit()"
>
  <main class="title-simple-steps mb-4 mt-2 field-group">
    <h1>
      {{ "Tell_Us_About_Your_Business" | translate }}
    </h1>
  </main>

  <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="mb-[4px]">
    <div fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="100">
      <mat-label class="label">
        {{ "business_name" | translate }} 
        <span class="text-[#6059a2]">*</span>
      </mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="{{ 'Enter_Your_Business_Name' | translate }}"
          formControlName="BusinessName"
        />
        <mat-error>
          <app-error-form
            [name]="'business_name' | translate"
            [control]="form.controls['BusinessName']"
            [maxLength]="30"
            [minLength]="4"
          ></app-error-form>
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div
    fxLayout="row wrap"
    fxLayoutAlign="space-between start"
    class="country-city-row"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxFlex="47"
    >
      <mat-label class="label">
        {{ "Country" | translate }}
        <span class="text-[#6059a2]">*</span>
      </mat-label>
      <ng-container *ngIf="!countriesLoading; else countrySkeleton">
        <mat-form-field appearance="outline">
          <mat-select
            disableRipple
            formControlName="CountryId"
            (selectionChange)="onChangeCountry($event)"
            [placeholder]="'Country' | translate"
          >
            <mat-option *ngFor="let country of countries" [value]="country.Id">
              {{ dir == 'rtl' ? country.NameAr : country.NameEn }}
            </mat-option>
          </mat-select>
          <mat-error>
            <app-error-form
              [name]="'Country' | translate"
              [control]="form.controls['CountryId']"
            ></app-error-form>
          </mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #countrySkeleton>
        <div class="basic-details-skeleton basic-details-skeleton-field"></div>
      </ng-template>
    </div>

    <div
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxFlex="47"
    >
      <mat-label class="label">
        {{ "City" | translate }}
        <span class="text-[#6059a2]">*</span>
      </mat-label>
      <ng-container *ngIf="!citiesLoading; else citySkeleton">
        <mat-form-field appearance="outline">
          <mat-select
            disableRipple
            formControlName="CityId"
            [placeholder]="'City' | translate"
          >
            <mat-option *ngFor="let city of cities" [value]="city.Id">
              {{ dir == 'rtl' ? city.NameAr : city.NameEn }}
            </mat-option>
          </mat-select>
          <mat-error>
            <app-error-form
              [name]="'City' | translate"
              [control]="form.controls['CityId']"
            ></app-error-form>
          </mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #citySkeleton>
        <div class="basic-details-skeleton basic-details-skeleton-field"></div>
      </ng-template>
    </div>
  </div>

  <div class="field-group">
    <p class="mb-1 label">
      {{ "BusinessType" | translate }}
      <span class="text-[#6059a2]">*</span>
    </p>

    <div *ngIf="businessTypesLoading" class="business-types-grid business-types-grid-skeleton" fxLayout="row wrap" fxLayoutGap="24px 16px">
      <div class="basic-details-skeleton basic-details-skeleton-card" *ngFor="let i of [1,2,3,4,5,6]"></div>
    </div>

    <div *ngIf="!businessTypesLoading" class="gap-30 business-types-grid" fxLayout="row wrap" fxLayoutAlign="start start">
      <div
        *ngFor="let type of businessType"
        class="b-type-row"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex.gt-sm="48"
        fxFlex.lt-md="100"
        [ngClass]="{
          'not-allowed': notAllowedBusinessTypes.includes(type?.BusinessType)
        }"
      >
        <mat-checkbox
          class="business-type-checkbox"
          [checked]="type.active"
          [disabled]="notAllowedBusinessTypes.includes(type?.BusinessType)"
          (change)="onSelectBusinessType(type)"
          color="primary"
        ></mat-checkbox>
        <div
          class="business-type-content"
          [ngClass]="{ 'selected': type.active }"
          (click)="onSelectBusinessType(type)"
        >
          <img
            [src]="type.ImagePath"
            [alt]="dir == 'rtl' ? type.NameAr : type.NameEn"
            [title]="dir == 'rtl' ? type.NameAr : type.NameEn"
          />
          <span>{{ dir == 'rtl' ? type.NameAr : type.NameEn }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-[4px]">
    <div
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxFlex="100"
    >
      <mat-label class="label">{{ "HOW_DID_U_KNOW_US" | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select
          disableRipple
          formControlName="KnowUsWayId"
          [placeholder]="'HOW_DID_U_KNOW_US' | translate"
        >
          <mat-option *ngFor="let item of knowUsWays" [value]="item.Id">
            <img
              [src]="item?.ImagePath ?? ''"
              alt=""
              class="img-icon"
              [title]="dir == 'rtl' ? item.NameAr : item.NameEn"
            />
            <span class="ms-2">{{ dir == 'rtl' ? item.NameAr : item.NameEn }}</span>
          </mat-option>
        </mat-select>
        <mat-error>
          <app-error-form
            [name]="'HOW_DID_U_KNOW_US' | translate"
            [control]="form.controls['KnowUsWayId']"
          ></app-error-form>
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="field-group">
    <div
      fxLayout="column"
      fxLayoutAlign="start stretch"
      fxFlex="100"
    >
      <label class="label">
        {{ "ARE_U_CURRENTLY_USING_SYSTEM" | translate }}
      </label>
      <mat-radio-group
        class="are-you-using-radio-group"
        formControlName="IsCurrentlyUsingAnyOtherSystem"
      >
        <mat-radio-button [value]="true" color="primary">
          {{ "Yes" | translate }}
        </mat-radio-button>
        <mat-radio-button class="mlr-30" [value]="false" color="primary">
          {{ "No" | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <button
    mat-raised-button
    color="primary"
    class="submit-btn"
    type="submit"
    [disabled]="!canSubmit || loading"
  >
    {{ "Next" | translate }}
    <span class="btn-spinner-icon" *ngIf="loading"></span>
  </button>
</form>
